import styled from "styled-components";

export const FixturePanel = styled.div`
  margin: 10px 0;
  font-size: 13px;
`;

export const Team = styled.span<{ selected?: boolean }>`
  font-weight: ${(props) => (props.selected ? "bold" : "noraml")};
`;

export const ChartIconPanel = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  b {
    margin-right: 10px;
  }
`;

export const ChartIcon = styled.div`
  img {
    height: 26px;
    width: 26px;
  }
`;

export const StatsPanel = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: -17px;
  margin-right: -17px;
  margin-bottom: 15px;
  background-color: ${(props) => props.theme.pageBackground};
`;

export const StatsItem = styled.div`
  display: flex;
  align-items: center;
  flex: 1 0;
  width: 50%;
  flex-direction: column;
  padding: 15px;
  font-size: 13px;
  &:not(:last-child) {
    border-right: 0.5px solid ${(props) => props.theme.sepColor};
  }
  b {
    font-size: 14px;
  }
`;

export const Percentage = styled.div<{ isGreen?: boolean }>`
  color: ${(props) =>
    props.isGreen ? props.theme.probabilityHighlight : props.theme.lightGrey};
`;

export const ChartPanel = styled.div`
  padding: 20px 0px;
  margin-left: -17px;
  margin-right: -17px;
  margin-bottom: 15px;
  border-top: 0.5px solid ${(props) => props.theme.sepColor};
  border-bottom: 0.5px solid ${(props) => props.theme.sepColor};
`;
